import React, { Component } from 'react';

import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import Compare from 'helpers/Compare';
import PropTypes from 'prop-types';

import { ContentList } from './index';

import './ContentDetails.scss';

export default class NotConcludedContent extends Component {
  static propTypes = {
    defaultSortName: PropTypes.string,
    defaultOrderBy: PropTypes.oneOf(Object.values(Compare.ORDER_BY)),
    content: PropTypes.arrayOf(PropTypes.object)
  };

  get columns() {
    const { defaultSortName, defaultOrderBy } = this.props;

    return [
      {
        name: 'moduleName',
        label: 'general.module',
        type: Compare.DATA_TYPES.TEXT,
        defaultOrderBy,
        order: 1,
        sortName: defaultSortName,
        value: 'moduleName'
      },
      {
        name: 'name',
        label: 'general.page',
        type: Compare.DATA_TYPES.TEXT,
        order: 2,
        value: 'name',
        sortName: 'name'
      }
    ];
  }

  render() {
    const { defaultSortName, defaultOrderBy, content } = this.props;

    return (
      <Grid block className="content__details">
        <h2 className="content_title">
          <I18n label="users_manager.users_detail.not_concluded_class" />
        </h2>
        {content && content.length ? (
          <ContentList
            columns={this.columns}
            items={content}
            defaultSortOptions={{ [`${defaultSortName}`]: defaultOrderBy }}
          />
        ) : (
          <div className="empty_content">
            <I18n label="users_manager.users_detail.empty_not_concluded_class" />
          </div>
        )}
      </Grid>
    );
  }
}
